/**
 * Auth0 user profile fields the SPA cares about. The full claim set is
 * passed through but only this subset is typed.
 */
export interface Auth0User {
  readonly sub: string;
  readonly email?: string;
  readonly email_verified?: boolean;
  readonly name?: string;
  readonly given_name?: string;
  readonly family_name?: string;
  readonly picture?: string;
  readonly org_id?: string;
  readonly [claim: string]: unknown;
}

/**
 * Account shape returned by `GET /v1/users/me?expand[]=accounts`.
 *
 * Once the OpenAPI client lands this will be replaced by the generated type.
 * Until then we hand-roll the minimum we use in Phase A.
 */
export interface Account {
  readonly id: number;
  readonly name: string;
  readonly subdomain: string | null;
  readonly organizationId: string | null;
  readonly isDemo: boolean;
  readonly logoUrl: string | null;
}

export interface MeUser {
  readonly id: number;
  readonly sub: string;
  readonly email: string;
  readonly firstName: string | null;
  readonly lastName: string | null;
  readonly jobTitle: string | null;
  readonly growzzRole: string | null;
  readonly country: { id: number; name: string } | null;
  readonly accounts?: readonly Account[];
}

/**
 * Patch payload for `PATCH /users/me`. Mirrors the legacy
 * `AuthService.updateUser()` shape — only the fields the user can edit
 * during onboarding / settings are listed.
 */
export interface UpdateProfilePayload {
  readonly firstName?: string;
  readonly lastName?: string;
  readonly jobTitle?: string;
  readonly growzzRole?: string;
}

/**
 * Whether a user has completed the onboarding profile capture.
 * Mirrors the legacy guard which keys off `first_name` and `last_name`.
 */
export function isProfileComplete(
  user: Pick<MeUser, 'firstName' | 'lastName'> | null | undefined,
): boolean {
  return !!user && !!user.firstName?.trim() && !!user.lastName?.trim();
}
